.checkbox-tree__header {
  display: block;
  font-weight: var(--semibold);
  margin-bottom: 0.25rem;
  text-align: left;
}

.checkbox-tree__branch {
  list-style: none;
  user-select: none;
}

.checkbox-tree__branch[aria-expanded="false"] {
  margin-bottom: 0.5rem;
}

.checkbox-tree__branch input[type="checkbox"]:disabled + label {
  color: var(--color-grey-500);
}

.checkbox-tree__branch--icon {
  pointer-events: none;
  transform: rotate(0deg);
  transition: transform 300ms ease-out;
}

.checkbox-tree__branch--icon--expanded {
  transform: rotate(90deg);
  transition: transform 300ms ease-in;
}

.checkbox-tree__branch--formfield {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.checkbox-tree__leaves {
  display: none;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  margin: 0.5rem 0 0.5rem 1rem;
  user-select: none;
}

.checkbox-tree__leaves--expanded {
  display: flex;
}

.checkbox-tree__leaf {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0 0.5rem;
  margin-left: 1.5rem;
  user-select: none;
}

.checkbox-tree__leaf input[type="checkbox"]:disabled + label {
  color: var(--color-grey-500);
}
